import type { AppDispatch } from "redux/store";
import type { IDefaultNotification, INotificationHistory } from "./reducer";
import { 
    SET_NOTIFICATION_TABLE_HISTORY_DATA, 
    SET_NOTIFICATION_TABLE_HISTORY_ERROR, 
    SET_NOTIFICATION_TABLE_HISTORY_LOADING,
    SET_CURRENT_HISTORY_NOTIFICATION,
    SET_CURRENT_HISTORY_NOTIFICATION_LOADING,
    SET_CURRENT_HISTORY_NOTIFICATION_ERROR,
    SET_HISTORY_NOTIFICATION_TABLE_PARAMS,
    SET_NOTIFICATION_HISTORY_DROPDOWN,
    SET_NOTIFICATION_HISTORY_DROPDOWN_ERROR,
    SET_LAST_DROPDOWN_NOTIFICATION_ID
} from "./constants";
import { tasksService } from "api";
import { tasksAdapter } from "./adapters";
import { TaskStatusesList } from "api/services/tasks/models";

export const getAndSetPermanentNotififcations = (params: {[key: string]: string | number}) => async (dispatch: AppDispatch, getState: any) => {
    try {
        dispatch(setNotificationsTableHistoryLoading(true));
        const res = await tasksService.getTasks(params);
        const data = res.data.data.items;

        if(data) {
            const mappedData = tasksAdapter(data);
            dispatch(setNotificationsTableHistory({data: mappedData, total: res.data.data.total || 0}));
        }

    } catch (error: any) {
        console.error(error.message)
        dispatch(setNotificationsTableHistoryError(error.message))
    } finally {
        dispatch(setNotificationsTableHistoryLoading(false));
    }
}

export const getDropdownHistoryNotifications = (params: {[key: string]: string | number}) => async (dispatch: AppDispatch, getState: any) => {
    try {
        const res = await tasksService.getTasks(params);
        const data = res.data.data.items;
        const dropdownNotifications = getState().notifications.notificationsHistory.dropdown;
        const lastDropdownNotificationUpdatedAt = dropdownNotifications && dropdownNotifications[0] ? dropdownNotifications[0]?.updatedAt : '';

        if(data.length > 0) {
            if(lastDropdownNotificationUpdatedAt !== data[0]?.updatedAt) {
                const mappedData = tasksAdapter(data);
                dispatch(setNotificationHistoryDropdown(mappedData));
                dispatch(setLastDropdownNotificationId(data[0].id));
            }
        }

    } catch (error: any) {
        console.error(error.message)
        dispatch(setNotificationHistoryDropdownError(error.message))
    } 
}

export const setLastDropdownNotificationId = (id: number) => ({
    type: SET_LAST_DROPDOWN_NOTIFICATION_ID,
    payload: id
})

export const setNotificationHistoryDropdown = (data: INotificationHistory[]) => ({
    type: SET_NOTIFICATION_HISTORY_DROPDOWN,
    payload: data
})

export const setNotificationHistoryDropdownError = (data: INotificationHistory[]) => ({
    type: SET_NOTIFICATION_HISTORY_DROPDOWN_ERROR,
    payload: data
})

export const getCurrentHistoryNotificationById = (id: number) => async (dispatch: AppDispatch) => {
    try {
        dispatch(setCurrentNotifiationLoading(true));

        const res = await tasksService.getTaskById(id);
        const data = res.data?.data;

        if(data) {
            dispatch(setCurrentNotifiationData(data));
        } else {
            throw new Error("Not found");
        }

    } catch (error: any) {
        console.error(error.message);
        dispatch(setCurrentNotifiationError(error.message));
    } finally {
        dispatch(setCurrentNotifiationLoading(false));
    }
}

export const setHistoryNotificationTableParams = (params: {[key: string]: number | string}) => ({
    type: SET_HISTORY_NOTIFICATION_TABLE_PARAMS,
    payload: params
})

export const setCurrentNotifiationData = (data: INotificationHistory) => ({
    type: SET_CURRENT_HISTORY_NOTIFICATION,
    payload: data
})

export const setCurrentNotifiationLoading = (data: boolean) => ({
    type: SET_CURRENT_HISTORY_NOTIFICATION_LOADING,
    payload: data
})

export const setCurrentNotifiationError = (data: string) => ({
    type: SET_CURRENT_HISTORY_NOTIFICATION_ERROR,
    payload: data
})

export const setNotificationsTableHistoryLoading = (data: boolean) => ({
    type: SET_NOTIFICATION_TABLE_HISTORY_LOADING,
    payload: data
})

export const setNotificationsTableHistory = (data: {data: INotificationHistory[], total: number}) => ({
    type: SET_NOTIFICATION_TABLE_HISTORY_DATA,
    payload: data
})

export const setNotificationsTableHistoryError = (data: string) => ({
    type: SET_NOTIFICATION_TABLE_HISTORY_ERROR,
    payload: data
})

export const setTemporaryNotifications = (data: any) => ({
    type: "SET_TEMPORARY_NOTIFICATIONS",
    payload: data
})

export const deleteTemporaryNotification = (data: IDefaultNotification) => ({
    type: "DELETE_TEMPORARY_NOTIFICATION",
    payload: data
})